import type { PouchSize } from "@./cat-calculations";
import { Decimal, toCurrencyDecimalsString } from "@/decimal-util";
import type { PricingPlan } from "@/primary-models";
import type { SerialType } from "@utils/types";

import type { IFreshPricingPlan } from "./types/meal-plan.types";

type TMealPlanPricing = IFreshPricingPlan | SerialType<IFreshPricingPlan>;

export const getMealPlanPricePerDay = (
  availableMealPlans: readonly TMealPlanPricing[],
  pricingPlan: PricingPlan,
  pouchSize: PouchSize,
): string => {
  const mealPlan = availableMealPlans.find(
    (availableMealPlan) => availableMealPlan.pricingPlan === pricingPlan,
  );

  if (!mealPlan) {
    throw new Error(
      `Meal plan ${pricingPlan} not found in available meal plans`,
    );
  }

  return toCurrencyDecimalsString(
    new Decimal(mealPlan.traySize[pouchSize].price).div(mealPlan.cadence),
  );
};
